import React from 'react';
import { Flexer, Link } from '@ontruck/orc';

import CopyButton from 'modules/Common/Copy/CopyButton';

import { isLockedToAgents } from 'modules/locked-to-agents';

import SetOrderToManual from './SetOrderToManual';

const t = {
  copy_details: 'Copy job details',
  view_matched_vehicles: 'View vehicles that can do the job',
  fleet_tab: 'This order should me managed from Fleet tab',
};

const Actions = ({ copyDetail, viewValidVehicles, item }) => {
  if (isLockedToAgents(item)) {
    return <SetOrderToManual id={item?.id} />;
  }

  return (
    <>
      <div>
        <Flexer.Parent mBottom="S">
          <div>{t.fleet_tab}</div>
        </Flexer.Parent>
        <Flexer.Parent alignItems="center">
          <Flexer.Child mRight="S" mBottom="S">
            <CopyButton text={t.copy_details} onClick={copyDetail} />
          </Flexer.Child>
          <Flexer.Child mBottom="S">
            <Link
              noWrap
              skin="secondary"
              text={t.view_matched_vehicles}
              onClick={viewValidVehicles}
              dataE2E={'detail__viewValidVehicles'}
            />
          </Flexer.Child>
        </Flexer.Parent>
      </div>
    </>
  );
};

export default Actions;
